import {Button, Form, Icon, Input} from "antd";
import logo from "../cProject-banner-new.png";
import React from "react";

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  signIn() {
    const { username, password } = this.state;
    const { onLogin } = this.props;
    onLogin && onLogin(username, password);
  }

  handleUserChange = (e) => {
    this.setState({ username: e.target.value });
  };

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.signIn();
  };

  render() {
    const {
      onStateChange
    } = this.props;
    const { username, password } = this.state;
    return (
      <Form id='sign-in' onSubmit={this.handleFormSubmit}>
        <img id='authlogo' src={logo} alt=''/>
        <Input
          key='username'
          name='username'
          prefix={<Icon type='user'/>}
          placeholder='Your username is your email address'
          value={username}
          onChange={this.handleUserChange}
          autoCorrect='off'
          autoCapitalize='none'
        />
        <Input
          key='password'
          name='password'
          type='password'
          prefix={<Icon type='lock'/>}
          placeholder='Password'
          value={password}
          onChange={this.handlePasswordChange}
        />
        <div>
          Forgot your password? <a onClick={() => onStateChange('forgotPassword')}>Reset password</a>
        </div>
        <Button
          type='primary'
          htmlType='submit'
          className='full-width'
        >
          Log In
        </Button>
        <div id={'login-issues'}>
          If you are having trouble logging in, please email us at <a href={'mailto:support@cproject.com'}>support@cproject.com</a>.
        </div>
      </Form>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Security/SignIn.js